import { Component } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { ConfirmService } from '../../../shared/components/confirm/confirm.service';
import { ConfirmModule } from '../../../shared/components/confirm/confirm.module';

@Component({
  selector: 'app-logout',
  templateUrl: 'logout.component.html',
  standalone: true,
  imports: [ConfirmModule],
})
export class LogoutComponent {

  constructor(
    private authService: AuthService,
    private readonly confirmService: ConfirmService,
  ) {}

  async logout() {
    const confirm = await this.confirmService.confirm({ 
      message: 'Ești sigur/ă că vrei să te deconectezi?',
      header: 'Deconectare',
      confirmButtonText: 'Deconectare',
      cancelButtonText: 'Înapoi',
    });

    if (confirm) {
      this.authService.logout();
    }
  }
}
